@use "../../../styles/variables.scss" as *;

.pageHeader {
  &.pageHeaderLightTheme {
    background-color: $white;
  }

  &.pageHeaderDarkTheme {
    background-color: $almost-black;
  }

  &.pageHeaderVoltTheme {
    background: $light-volt;
    border-bottom: none;
  }

  &.pageHeaderWhiteTheme {
    background-color: $white;
  }
}

.contentContainer {
  height: 100%;

  &.contentContainerLightTheme {
    background-color: $almost-white;
  }

  &.contentContainerDarkTheme {
    background-color: $almost-black;
  }

  &.contentContainerVoltTheme {
    background: linear-gradient(180deg, $light-volt 0%, $almost-white 100%);
  }

  &.contentContainerWhiteTheme {
    background-color: $white;
  }

  &.contentContainerGrayTheme {
    background-color: $darker-beige;
  }

  .content {
    padding: 56px 16px 0;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    height: 100%;

    .passedContentWrapper {
      flex-grow: 1;
      height: 100%;
    }

    @media (min-width: $desktop-breakpoint) {
      padding: 56px 0 0;
    }

    &.contentSizeNarrow {
      max-width: 28rem;
    }

    &.contentSizeWide {
      max-width: 48rem;
    }

    &.contentSizeFull {
      max-width: 100vw;
      padding: 56px 0 0;
    }

    &.contentWithProgressBar {
      padding-top: 68px;
    }

    &.contentWithoutHeader {
      padding-top: 0;
    }

    &.errorPage {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 32px;
      height: 100%;

      .heroContainer {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;

        .errorHeading {
          color: $almost-black;
          font-family: $font-family-brand;
          font-size: 38px;
          font-weight: 400;
          line-height: 40px;
          margin: 0;
          text-align: center;
        }
      }

      .errorMessage {
        color: $almost-black;
        text-align: center;
        font-family: $font-family-brand;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        margin: 0;
      }

      .tryAgainButton {
        color: $almost-black;
        background-color: $almost-white;
        border: 1px solid $almost-black;
        border-radius: 9999px;
        padding: 16px;
        font-family: $font-family-body;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        width: calc(100% - 32px);
        cursor: pointer;
      }
    }

    &.contentWithErrorBanner {
      padding-top: 96px;

      &.contentWithProgressBar {
        padding-top: 108px;
      }
    }

    &.contentWithSuccessBanner {
      padding-top: 120px;

      &.contentWithProgressBar {
        padding-top: 132px;
      }
    }
  }
}

.errorBannerContainer {
  position: fixed;
  top: 56px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;

  &.errorBannerUnderProgressBar {
    top: 68px;
  }

  .errorBanner {
    background-color: $status-red-background;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 28rem;

    &.errorBannerWide {
      max-width: 48rem;
    }

    @media (min-width: $desktop-breakpoint) {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }

    .bannerContent {
      display: flex;
      gap: 8px;
      align-items: center;

      .alertIcon {
        color: $status-red-color;
        width: 20px;
        height: 20px;
      }

      .bannerMessageWrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .bannerText {
          color: $almost-black;
          font-family: $font-family-body;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
        }
      }
    }

    .closeButton {
      background-color: transparent;
      border: none;
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;

      svg {
        width: 20px;
        height: 20px;
        color: $almost-black;
      }
    }
  }
}

.successBannerContainer {
  position: fixed;
  top: 80px;
  width: 100%;
  display: flex;
  justify-content: center;

  &.successBannerUnderProgressBar {
    top: 92px;
  }

  .successBanner {
    background-color: $status-green-background;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 28rem;
    border-radius: 8px;

    &.successBannerWide {
      max-width: 48rem;
    }

    .bannerContent {
      display: flex;
      gap: 8px;
      align-items: center;

      .alertIcon {
        color: $status-green-stroke;
        width: 20px;
        height: 20px;
      }

      .bannerMessageWrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .bannerText {
          color: $almost-black;
          font-family: $font-family-body;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
        }
      }
    }

    .closeButton {
      background-color: transparent;
      border: none;
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;

      svg {
        width: 20px;
        height: 20px;
        color: $almost-black;
      }
    }
  }
}
